import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export default function DataTable({ title, endpoint, columns }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get(endpoint).then((r) => setRows(r.data)).catch(() => {}); }, [endpoint]);
  return (
    <div>
      <h1 className="font-serif-display text-2xl font-bold text-[#111827] mb-6">{title}</h1>
      <div className="border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>{columns.map((c) => <th key={c.key} className="text-left px-4 py-3 font-semibold text-slate-600">{c.label}</th>)}</tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {rows.length === 0 && <tr><td colSpan={columns.length} className="px-4 py-8 text-center text-slate-400">No records yet.</td></tr>}
            {rows.map((row) => (
              <tr key={row.id} data-testid={`table-row-${row.id}`} className="hover:bg-slate-50">
                {columns.map((c) => (
                  <td key={c.key} className="px-4 py-3 text-slate-700">
                    {c.key === "created_at" && row[c.key] ? new Date(row[c.key]).toLocaleString() : String(row[c.key] ?? "—")}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
